import { lazy } from 'react';
import { Navigate, type RouteObject } from 'react-router-dom';

const EventHome = lazy(() => import('../../marketing/pages/EventHome'));
const PricingPage = lazy(() => import('../../marketing/pages/Pricing'));
const BlogIndexPage = lazy(() => import('../../marketing/pages/BlogIndex'));
const BlogPostPage = lazy(() => import('../../marketing/pages/BlogPost'));
const ContactPage = lazy(() => import('../../marketing/pages/Contact'));
const StorePage = lazy(() => import('../../marketing/pages/Store'));
const PersonaPage = lazy(() => import('../../marketing/pages/PersonaPage'));
const SignupPage = lazy(() => import('../pages/Signup'));
const LoginPage = lazy(() => import('../pages/Login'));
const ForgotPasswordPage = lazy(() => import('../pages/ForgotPassword'));
const ResetPasswordPage = lazy(() => import('../pages/ResetPassword'));
const OnboardingPage = lazy(() =>
  import('../features/echange').then((module) => ({ default: module.EchangeOnboarding }))
);

export const publicRoutes: RouteObject[] = [
  {
    path: '/',
    element: <EventHome />,
  },
  {
    path: 'pricing',
    element: <PricingPage />,
  },
  {
    path: 'blog',
    element: <BlogIndexPage />,
  },
  {
    path: 'blog/:slug',
    element: <BlogPostPage />,
  },
  {
    path: 'contact',
    element: <ContactPage />,
  },
  {
    path: 'store',
    element: <StorePage />,
  },
  {
    path: 'personas/:slug',
    element: <PersonaPage />,
  },
  {
    path: 'about',
    element: <Navigate to="/#manifesto" replace />,
  },
  {
    path: 'features',
    element: <Navigate to="/#features" replace />,
  },
  {
    path: 'languages',
    element: <Navigate to="/#languages" replace />,
  },
  {
    path: 'temphomepage',
    element: <Navigate to="/" replace />,
  },
  {
    path: 'signup',
    element: <SignupPage />,
  },
  {
    path: 'login',
    element: <LoginPage />,
  },
  {
    path: 'forgot-password',
    element: <ForgotPasswordPage />,
  },
  {
    path: 'reset-password',
    element: <ResetPasswordPage />,
  },
  {
    path: 'onboarding',
    element: <OnboardingPage />,
  },
  {
    path: 'app-preview/*',
    element: <Navigate to="/dashboard" replace />,
  },
  {
    path: 'legacy/*',
    element: <Navigate to="/dashboard" replace />,
  },
  {
    path: '*',
    element: <Navigate to="/" replace />,
  },
];
